import styled from '@emotion/styled';

export const Content = styled.form`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 44px 0 30px;
  padding: 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.07);
  box-shadow: 0px 26px 59px 0px rgba(0, 0, 0, 0.18);
`;
